import { createSelector } from 'reselect';
import {
    filter, has, pick, values,
} from 'lodash';

/**
 * Base Selectors
 */
const getEntityId = (state, id) => id;
const getEntities = (state) => state.app.database.requestQuotes;
const getComponentEntities = (state) => state.app.database.requestQuoteComponents;
const getMetaEntities = (state) => state.app.metaDatabase.requestQuotes;

/**
 * Selector Builders
 */
export const buildMetaRequestQuoteSelector = () => createSelector([getEntityId, getMetaEntities], (entityId, entities) =>
{
    if (has(entities, entityId))
    {
        return entities[entityId];
    }

    return {};
});

export const buildRequestQuoteSelector = () => createSelector([getEntityId, getEntities, getComponentEntities], (entityId, entities, requestQuoteComponents) =>
{
    if (has(entities, entityId))
    {
        const requestQuote = entities[entityId];

        return {
            ...requestQuote,
            requestQuoteComponents: values(pick(requestQuoteComponents, requestQuote.requestQuoteComponents)),
        };
    }

    return {};
});

export const buildRequestQuotesByRequestIdSelector = () => createSelector([getEntityId, getEntities, getComponentEntities], (entityId, entities, requestQuoteComponents) => filter(entities, { request_id: entityId }).map((requestQuote) => ({
    ...requestQuote,
    requestQuoteComponents: values(pick(requestQuoteComponents, requestQuote.requestQuoteComponents)),
})));
